import { JOVE_PRICE_UNIT_CURRENCY_KEY, JOVE_PRICE_UNIT_PERCENT_KEY } from '../constants/common';
import { getJoveCountryCurrencySymbolNativeWithCountry } from './currency';
export var getPriceOrPercentDisplayText = function getPriceOrPercentDisplayText(value, unit, config) {
  if (unit === JOVE_PRICE_UNIT_PERCENT_KEY) {
    return "".concat(Number(value || 0), "%");
  } else if (unit === JOVE_PRICE_UNIT_CURRENCY_KEY) {
    return "".concat(getJoveCountryCurrencySymbolNativeWithCountry(config === null || config === void 0 ? void 0 : config.country)).concat(Number(value || 0));
  } else {
    return value;
  }
};